export default (value) => value === '' || value === null || value === undefined;
